import * as React from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'
import {
  loadBusinessSettings,
  updateBusinessSettings,
} from '@disco/state-management/actions/UserActions'
import {
  CUSTOM_DOWNLOAD_FILE_NAMES,
  TRANSCODE_320K,
} from '@disco/constants/FeatureTypes'
import { useFeatureData } from '@disco/state-management/selectors/business'
import { getBusinessTypeV2 } from '@disco/state-management/selectors/user'
import BusinessSettings from './BusinessSettings'

const BusinessSettingsContainer = (): React.ReactNode => {
  const dispatch = useDispatch()
  const featureData = {
    [CUSTOM_DOWNLOAD_FILE_NAMES]: useFeatureData(CUSTOM_DOWNLOAD_FILE_NAMES),
    [TRANSCODE_320K]: useFeatureData(TRANSCODE_320K),
  }
  const actions = {
    updateBusinessSettings,
    loadBusinessSettings,
    sendMixpanelEvent,
  }
  Object.keys(actions).forEach(key => {
    const action = actions[key]

    actions[key] = (...actionProps) => dispatch(action(...actionProps))
  })
  const user = useSelector(state => state.user)
  const businessType = useSelector(getBusinessTypeV2)
  const props = {
    user,
    // @ts-expect-error
    businessSettings: user.businessSettings,
    featureData,
    businessType,
    ...actions,
  }
  return <BusinessSettings {...props} />
}

export default BusinessSettingsContainer
